module.exports = "/_next/static/images/Frank-4e9cdecdedae565a14b017cca4a11f22.svg";